import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import { daysOfWeek, initialSlots } from "../../config";

const AuditSlotTimePicker = ({ slot = {}, selectedDay, handleDaySelect }) => {
  const [allSlots, setAllSlots] = useState({ ...initialSlots, ...slot });

  useEffect(() => {
    setAllSlots({ ...initialSlots, ...slot });
  }, [slot]);

  useEffect(() => {
    if (!selectedDay) {
      handleDaySelect("0");
    }
  }, [selectedDay, handleDaySelect]);

  const timeSlots = Object.keys(initialSlots[Object.keys(initialSlots)[0]]);

  return (
    <div className="slot-time-picker">
      <div className="day-buttons mt-2">
        {Object.keys(initialSlots)?.map((day) => (
          <Button
            key={day}
            variant={selectedDay === day ? "success" : "light"}
            onClick={() => handleDaySelect(day)}
          >
            {daysOfWeek[day]}
          </Button>
        ))}
      </div>
      <br />
      {selectedDay && (
        <div className="time-slot-grid">
          {timeSlots?.map((timeSlot) => (
            <Button
              key={timeSlot}
              variant={allSlots[selectedDay]?.[timeSlot] ? "success" : "light"}
              style={{ width: "80px", marginBottom: "5px" }}
            >
              {timeSlot}
            </Button>
          ))}
        </div>
      )}
    </div>
  );
};

export default AuditSlotTimePicker;